import React from "react";

const TermsOfUse = () => {
	return (
		<>
			<div>
				<h1>Terms of Use</h1>
				<h2>Last Updated: 28/02/25</h2>
				<p>
					Welcome to Watchflix. By accessing or using our services, you agree to
					comply with and be bound by the following terms and conditions. Please
					read these Terms of Use carefully before using our platform.
				</p>
				<br />
				<ul>
					<li>
						<span>Acceptance of Terms</span>
						<p>
							By using Watchflix, you agree to these Terms of Use and our
							Privacy Policy. If you do not agree, please do not use our
							services.
						</p>
					</li>
					<li>
						<span>Eligibility</span>
						<p>
							You must be at least 18 years old to use our services. By using
							our platform, you confirm that you meet this requirement.
						</p>
					</li>
					<li>
						<span>User Responsibilities</span>
						<ul>
							<li>You agree to use our services only for lawful purposes.</li>
							<li>
								You are responsible for maintaining the confidentiality of your
								account and password.
							</li>
							<li>
								You agree not to engage in any activity that disrupts or
								interferes with our services.
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</>
	);
};

export default TermsOfUse;
